import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import Validation from "../utills/Validation";
import { DomainUrl } from "../utills/CommonData";
import axios from "axios";
import FeedbackSuccess from "./FeedbackSuccess";

const Feedback = () => {
  const [hover, setHover] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [feedback, setFeedback] = useState({
    rating: null,
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setIsOpen(false);
        setFeedback({ rating: null, email: "", phone: "", message: "" }); // Reset form
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, [isOpen]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFeedback((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleRating = (star) => {
    setFeedback((prevState) => ({
      ...prevState,
      rating: star,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errorsValidation = Validation(feedback);
    setErrors(errorsValidation);
    if (Object.keys(errorsValidation).length === 0) {
      try {
        console.log("feedback", feedback);
        const response = await axios.post(`${DomainUrl}/feedback`, feedback, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("response", response);

        if (response.data.success) {
          console.log("Feedback submitted successfully:", response.data);
          setIsOpen(true);
        } else {
          console.error("Server responded with an error:", response.data);
        }
      } catch (error) {
        console.error("Error submitting feedback:", error);
      }
    }
  };

  return (
    <>
      {!isOpen ? (
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-3 max-w-md  p-6"
        >
          <h2 className=" font-semibold">Rate Our Product</h2>

          <div className="flex gap-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                size={30}
                className={`cursor-pointer transition-colors ${
                  (hover || feedback.rating) >= star
                    ? "text-error"
                    : "text-white"
                }`}
                onClick={() => handleRating(star)}
                onMouseEnter={() => setHover(star)}
                onMouseLeave={() => setHover(null)}
                onChange={handleInputChange}
              />
            ))}
          </div>
          {errors.rating && (
            <p className="text-error text-sm">{errors.rating}</p>
          )}

          <label htmlFor="email" className=" font-semibold">
            Your Email
          </label>
          <input
            id="email"
            value={feedback.email}
            onChange={handleInputChange}
            name="email"
            type="email"
            placeholder="Enter your email"
            className="w-full text-black p-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-error"
          />
          {errors.email && <p className="text-error text-sm">{errors.email}</p>}

          <label htmlFor="phone" className=" font-semibold">
            Your Contact Number
          </label>
          <input
            id="phone"
            value={feedback.phone}
            type="tel"
            name="phone"
            onChange={handleInputChange}
            placeholder="Enter your mobile number"
            className="w-full text-black p-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-error"
          />
          {errors.phone && <p className="text-error text-sm">{errors.phone}</p>}

          <label htmlFor="message" className=" font-semibold">
            Your feedback helps us improve our service.
          </label>
          <textarea
            id="message"
            value={feedback.message}
            placeholder="Start writing here..."
            className="w-full p-3 border text-black rounded-lg focus:outline-none focus:ring-2 focus:ring-error"
            rows="4"
            name="message"
            onChange={handleInputChange}
          ></textarea>
          {errors.message && (
            <p className="text-error text-sm">{errors.message}</p>
          )}

          <button
            type="submit"
            className="mt-4 w-44 px-2 py-2 mx-auto  text-white font-semibold rounded-full border hover:border-neutral hover:bg-white hover:text-black transition"
          >
            Submit Feedback
          </button>
        </form>
      ) : (
        <FeedbackSuccess />
      )}
    </>
  );
};

export default Feedback;
